module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-stepper', {
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-stepper-header', [_c('v-stepper-step', {
    attrs: {
      "complete": _vm.step > 1,
      "step": "1"
    }
  }, [_vm._v("Customer")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.step > 2,
      "step": "2"
    }
  }, [_vm._v("Vehicles")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.step > 3,
      "step": "3"
    }
  }, [_vm._v("Select Products")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.step > 4,
      "step": "4"
    }
  }, [_vm._v("Assign Products")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.step > 5,
      "step": "5"
    }
  }, [_vm._v("Finance")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.step > 6,
      "step": "6"
    }
  }, [_vm._v("Contact")])], 1), _vm._v(" "), _c('v-stepper-items', [_c('v-stepper-content', {
    staticClass: "pt-5",
    attrs: {
      "step": "1"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.customerList,
      "loading": _vm.gettingCustomers,
      "label": "Select a Customer",
      "item-text": "name",
      "hide-details": "",
      "item-value": "key"
    },
    model: {
      value: (_vm.customer),
      callback: function($$v) {
        _vm.customer = $$v
      },
      expression: "customer"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.customer,
      "depressed": ""
    },
    on: {
      "click": _vm.step2
    }
  }, [_vm._v("Next")])], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addVehicleDialog = true
      }
    }
  }, [_vm._v("Add Vehicle")]), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "color": "primary",
      "disabled": _vm.vehicles.length === 0,
      "depressed": ""
    },
    on: {
      "click": _vm.step3
    }
  }, [_vm._v("Next")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search"
    },
    model: {
      value: (_vm.searchVehicles),
      callback: function($$v) {
        _vm.searchVehicles = $$v
      },
      expression: "searchVehicles"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "items": _vm.vehicleList,
      "hide-actions": "",
      "loading": _vm.gettingVehicles,
      "search": _vm.searchVehicles,
      "item-key": "id",
      "select-all": "",
      "headers": [{
        text: 'Row',
        value: 'index',
        sortable: false
      }, {
        text: 'Vehicle ID.',
        value: 'friendlyId',
        sortable: true
      }, {
        text: 'Vehicle Reg.',
        value: 'VehicleReg',
        sortable: true
      }, {
        text: 'Make.',
        value: 'Make',
        sortable: true
      }, {
        text: 'Model.',
        value: 'Model',
        sortable: true
      }, {
        text: 'Year Reg.',
        value: 'Year',
        sortable: true
      }, {
        text: 'Added',
        value: 'Added',
        sortable: true
      }, {
        text: 'Actions',
        value: 'actions',
        sortable: false,
        align: 'right'
      }],
      "pagination": _vm.vehiclePagination
    },
    on: {
      "update:pagination": function($event) {
        _vm.vehiclePagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              props.selected = !props.selected
            }
          }
        }, [_c('td', [_c('v-checkbox', {
          attrs: {
            "primary": "",
            "hide-details": "",
            "value": props.selected
          }
        })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.friendlyId ? props.item.friendlyId : 'TBC'))]), _vm._v(" "), _c('td', {
          style: (props.item.VehicleReg ? 'font-style: normal;' : 'font-style: italic;')
        }, [_vm._v(_vm._s(props.item.VehicleReg ? props.item.VehicleReg : props.item.friendlyId ? props.item.friendlyId : 'TBC'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.Make))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.Model))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.Year))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(props.item.Added))), (props.item.New == true) ? _c('v-chip', {
          attrs: {
            "color": "green",
            "text-color": "white",
            "small": ""
          }
        }, [_vm._v("New")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteVehicle(props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("delete")])], 1)], 1)])]
      }
    }]),
    model: {
      value: (_vm.vehicles),
      callback: function($$v) {
        _vm.vehicles = $$v
      },
      expression: "vehicles"
    }
  }, [_vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "error",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n                    Your search for \"" + _vm._s(_vm.searchVehicles) + "\" found no results.\n                  ")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": _vm.step1
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": _vm.vehicles.length === 0,
      "depressed": ""
    },
    on: {
      "click": _vm.step3
    }
  }, [_vm._v("Next")])], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": _vm.jobsToCreate.length === 0,
      "depressed": ""
    },
    on: {
      "click": _vm.step4
    }
  }, [_vm._v("Next")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Products to Install")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Only Show Installed Devices"
    },
    model: {
      value: (_vm.onlyShowInstalledDevices),
      callback: function($$v) {
        _vm.onlyShowInstalledDevices = $$v
      },
      expression: "onlyShowInstalledDevices"
    }
  }), _vm._v(" "), _vm._l((_vm.vehicles), function(vehicle, i) {
    return _c('v-flex', {
      key: i,
      attrs: {
        "xs12": ""
      }
    }, [_c('v-card', {
      staticClass: "elevation-8 ma-4"
    }, [_c('v-btn', {
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.toggleReg(i)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(_vm.expandedRegs.includes(i) ? 'mdi-minus' : 'mdi-plus'))])], 1), _vm._v(" "), _c('v-card-title', {
      attrs: {
        "primary-title": ""
      }
    }, [_c('h1', [(vehicle.VehicleReg) ? _c('span', [_vm._v(_vm._s(vehicle.VehicleReg + ' - '))]) : _vm._e(), _vm._v(_vm._s(vehicle.friendlyId))]), _vm._v(" "), (_vm.expandedRegs.includes(i)) ? _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [(!vehicle.installedDevices || Object.keys(vehicle.installedDevices).length < 1) ? _c('h4', [_vm._v("No Installed Devices")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.parentProducts), function(parent) {
      return [(_vm.templates.some(function (item) {
        return Object.keys(vehicle.installedDevices).includes(item.id) && item.parent === parent.value
      }) || !_vm.onlyShowInstalledDevices) ? _c('h3', [_c('v-btn', {
        attrs: {
          "flat": ""
        },
        on: {
          "click": function($event) {
            return _vm.toggleParent(parent.value + i)
          }
        }
      }, [_c('v-icon', [_vm._v(_vm._s(_vm.expandedParentProducts.includes(parent.value + i) ? 'mdi-minus' : 'mdi-plus'))]), _vm._v(" " + _vm._s(parent.text))], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.templates), function(template) {
        return (_vm.expandedParentProducts.includes(parent.value + i)) ? [(template.parent === parent.value && (Object.keys(vehicle.installedDevices).indexOf(template.id) !== -1 || !_vm.onlyShowInstalledDevices)) ? _c('v-select', {
          key: i + template.id,
          staticClass: "ml-5",
          attrs: {
            "label": _vm.templatesKeyVal[template.id],
            "items": ['Service Call', 'Sim Swap', 'De & Re', 'De-Install', 'Re-Install'],
            "multiple": "",
            "chips": "",
            "deletable-chips": ""
          },
          model: {
            value: (vehicle.Actions[template.id]),
            callback: function($$v) {
              _vm.$set(vehicle.Actions, template.id, $$v)
            },
            expression: "vehicle.Actions[template.id]"
          }
        }) : _vm._e()] : _vm._e()
      })]
    })], 2) : _vm._e()], 1)], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": _vm.step2
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": _vm.jobsToCreate.length === 0,
      "depressed": ""
    },
    on: {
      "click": _vm.step4
    }
  }, [_vm._v("Next")])], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "4"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": _vm.step5
    }
  }, [_vm._v("Next")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.clonedJobsToCreate), function(job, i) {
    return _c('v-flex', {
      key: i
    }, [_c('v-card', {
      staticClass: "elevation-8 ma-4"
    }, [_c('v-card-title', {
      attrs: {
        "primary-title": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('h3', {
      staticClass: "headline mb-0"
    }, [_vm._v(_vm._s(job.vehReg) + " - " + _vm._s(_vm.templatesKeyVal[job.jobType]))]), _vm._v(" "), _vm._l((job.actions), function(action) {
      return [_c('v-chip', {
        key: action,
        staticClass: "pb-1",
        attrs: {
          "label": "",
          "small": ""
        }
      }, [_vm._v(_vm._s(action))])]
    }), _vm._v(" "), (job.actions.indexOf('Service Call') !== -1) ? _c('v-textarea', {
      attrs: {
        "label": "Service Call Requirements"
      },
      model: {
        value: (job.requirements),
        callback: function($$v) {
          _vm.$set(job, "requirements", $$v)
        },
        expression: "job.requirements"
      }
    }) : _vm._e(), _vm._v(" "), (job.actions.indexOf('Sim Swap') !== -1) ? [_c('v-select', {
      attrs: {
        "items": ['Vodafone', 'EE', 'O2'],
        "value": "Vodafone",
        "label": "Network"
      },
      model: {
        value: (job.network),
        callback: function($$v) {
          _vm.$set(job, "network", $$v)
        },
        expression: "job.network"
      }
    }), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "label": "ICCID for new SIM",
        "type": "number"
      },
      model: {
        value: (job.ICCID),
        callback: function($$v) {
          _vm.$set(job, "ICCID", $$v)
        },
        expression: "job.ICCID"
      }
    }), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "label": "APN"
      },
      model: {
        value: (job.APN),
        callback: function($$v) {
          _vm.$set(job, "APN", $$v)
        },
        expression: "job.APN"
      }
    })] : _vm._e(), _vm._v(" "), (job.actions.indexOf('De & Re') !== -1) ? [_c('v-text-field', {
      attrs: {
        "label": "New Vehicle Reg"
      },
      model: {
        value: (job.newReg),
        callback: function($$v) {
          _vm.$set(job, "newReg", $$v)
        },
        expression: "job.newReg"
      }
    }), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "label": "New Make"
      },
      model: {
        value: (job.newMake),
        callback: function($$v) {
          _vm.$set(job, "newMake", $$v)
        },
        expression: "job.newMake"
      }
    }), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "label": "New Model"
      },
      model: {
        value: (job.newModel),
        callback: function($$v) {
          _vm.$set(job, "newModel", $$v)
        },
        expression: "job.newModel"
      }
    })] : _vm._e(), _vm._v(" "), (job.actions.indexOf('De-Install') !== -1) ? [_c('v-textarea', {
      attrs: {
        "label": "Where to leave kit"
      },
      model: {
        value: (job.leaveKit),
        callback: function($$v) {
          _vm.$set(job, "leaveKit", $$v)
        },
        expression: "job.leaveKit"
      }
    })] : _vm._e(), _vm._v(" "), (job.actions.indexOf('Re-Install') !== -1) ? [_c('v-textarea', {
      attrs: {
        "label": "Where to collect kit"
      },
      model: {
        value: (job.getKit),
        callback: function($$v) {
          _vm.$set(job, "getKit", $$v)
        },
        expression: "job.getKit"
      }
    })] : _vm._e()], 2)], 1)], 1)], 1)
  }), 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": _vm.step3
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": _vm.step5
    }
  }, [_vm._v("Next")])], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "5"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": _vm.step6
    }
  }, [_vm._v("Next")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Finance")]), _vm._v(" "), (!_vm.globalFinance && _vm.clonedJobsToCreate.length > 1) ? [_c('v-card', [_c('v-tabs', {
    model: {
      value: (_vm.activeFinanceTab),
      callback: function($$v) {
        _vm.activeFinanceTab = $$v
      },
      expression: "activeFinanceTab"
    }
  }, _vm._l((_vm.clonedJobsToCreate), function(job, i) {
    return _c('v-tab', {
      key: i
    }, [_vm._v("\n                        " + _vm._s(job.vehReg) + " - " + _vm._s(_vm.templatesKeyVal[job.jobType]) + "\n                      ")])
  }), 1), _vm._v(" "), _c('v-card-text', [_c('v-window', {
    model: {
      value: (_vm.activeFinanceTab),
      callback: function($$v) {
        _vm.activeFinanceTab = $$v
      },
      expression: "activeFinanceTab"
    }
  }, _vm._l((_vm.clonedJobsToCreate), function(job, i) {
    return _c('v-window-item', {
      key: i
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-select', {
      attrs: {
        "label": "Finance Type",
        "items": ['Chargeable', 'Warranty', 'Unknown']
      },
      model: {
        value: (job.finance.type),
        callback: function($$v) {
          _vm.$set(job.finance, "type", $$v)
        },
        expression: "job.finance.type"
      }
    }), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "label": "Customer PO"
      },
      model: {
        value: (job.finance.customerPO),
        callback: function($$v) {
          _vm.$set(job.finance, "customerPO", $$v)
        },
        expression: "job.finance.customerPO"
      }
    }), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "label": "Customer Cost",
        "type": "number",
        "step": "0.01",
        "prefix": "£"
      },
      model: {
        value: (job.finance.customerCost),
        callback: function($$v) {
          _vm.$set(job.finance, "customerCost", $$v)
        },
        expression: "job.finance.customerCost"
      }
    }), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "label": "Engineer Cost",
        "type": "number",
        "step": "0.01",
        "prefix": "£"
      },
      model: {
        value: (job.finance.supplierCost),
        callback: function($$v) {
          _vm.$set(job.finance, "supplierCost", $$v)
        },
        expression: "job.finance.supplierCost"
      }
    }), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "label": "Hardware Cost",
        "type": "number",
        "step": "0.01",
        "prefix": "£"
      },
      model: {
        value: (job.finance.hardwareCost),
        callback: function($$v) {
          _vm.$set(job.finance, "hardwareCost", $$v)
        },
        expression: "job.finance.hardwareCost"
      }
    })], 1)], 1)
  }), 1)], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.globalFinance || _vm.clonedJobsToCreate.length <= 1) ? [_c('v-select', {
    attrs: {
      "label": "Finance Type",
      "items": ['Chargeable', 'Warranty', 'Unknown']
    },
    model: {
      value: (_vm.finance.type),
      callback: function($$v) {
        _vm.$set(_vm.finance, "type", $$v)
      },
      expression: "finance.type"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Customer PO"
    },
    model: {
      value: (_vm.finance.customerPO),
      callback: function($$v) {
        _vm.$set(_vm.finance, "customerPO", $$v)
      },
      expression: "finance.customerPO"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Customer Cost",
      "type": "number",
      "step": "0.01",
      "prefix": "£"
    },
    model: {
      value: (_vm.finance.customerCost),
      callback: function($$v) {
        _vm.$set(_vm.finance, "customerCost", $$v)
      },
      expression: "finance.customerCost"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Engineer Cost",
      "type": "number",
      "step": "0.01",
      "prefix": "£"
    },
    model: {
      value: (_vm.finance.supplierCost),
      callback: function($$v) {
        _vm.$set(_vm.finance, "supplierCost", $$v)
      },
      expression: "finance.supplierCost"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Hardware Cost",
      "type": "number",
      "step": "0.01",
      "prefix": "£"
    },
    model: {
      value: (_vm.finance.hardwareCost),
      callback: function($$v) {
        _vm.$set(_vm.finance, "hardwareCost", $$v)
      },
      expression: "finance.hardwareCost"
    }
  })] : _vm._e()], 2)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": _vm.step4Back
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": _vm.step6
    }
  }, [_vm._v("Next")])], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "6"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Contact")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.contactDialog = true
      }
    }
  }, [_vm._v("Add Contact")])], 1), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "items": _vm.contacts,
      "multiple": "",
      "chips": "",
      "deletable-chips": "",
      "item-text": "Name",
      "item-value": "id",
      "label": "Relevant Contacts",
      "hint": "Please select any contacts that are relevant to this project."
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [
          [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(data.item.Name)), _vm._l((data.item.Site), function(site) {
            return [(_vm.sites[site]) ? _c('v-chip', {
              key: site,
              staticClass: "pb-1",
              attrs: {
                "label": "",
                "small": ""
              }
            }, [_vm._v(_vm._s(_vm.sites[site].Name))]) : _vm._e()]
          })], 2)], 1)]
        ]
      }
    }]),
    model: {
      value: (_vm.selectedContacts),
      callback: function($$v) {
        _vm.selectedContacts = $$v
      },
      expression: "selectedContacts"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.step = 5
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": _vm.saveCtnSheetDialog
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md8": ""
    }
  }, [_c('v-card-title', [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Attached Documents")]), _vm._v(" "), _c('upload-btn', {
    attrs: {
      "title": 'Attach New Document',
      "fileChangedCallback": _vm.attachFile
    }
  }, [_c('template', {
    slot: "icon"
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("mdi-paperclip")])], 1)], 2)], 1), _vm._v(" "), _c('v-card-text', [_c('v-list', _vm._l((_vm.attachedDocs), function(fileObj, key) {
    return _c('v-list-tile', {
      key: fileObj.file.name,
      attrs: {
        "two-line": ""
      }
    }, [_c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "color": "error",
        "disabled": _vm.savingCtnSheet
      },
      on: {
        "click": function($event) {
          return _vm.attachedDocs.splice(key, 1)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('span', {
      staticClass: "body-2"
    }, [_vm._v(_vm._s(fileObj.file.name))]), _vm._v(" "), _c('span', {
      staticClass: "caption ml-1"
    }, [_vm._v(_vm._s(_vm._f("formatBytes")(fileObj.file.size)))])]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('v-progress-linear', {
      attrs: {
        "value": fileObj.Progress,
        "color": fileObj.State === 0 ? 'primary' : fileObj.State === 1 ? 'blue' : fileObj.State === 2 ? 'warning' : fileObj.State === 3 ? 'success' : fileObj.State === 4 ? 'error' : 'primary'
      }
    })], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "450"
    },
    model: {
      value: (_vm.ctnSheetDialog),
      callback: function($$v) {
        _vm.ctnSheetDialog = $$v
      },
      expression: "ctnSheetDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Submit Service Call")]), _vm._v(" "), _c('v-card-text', [_c('v-textarea', {
    attrs: {
      "label": "Service Call",
      "rows": "3",
      "auto-grow": ""
    },
    model: {
      value: (_vm.acceptNote),
      callback: function($$v) {
        _vm.acceptNote = $$v
      },
      expression: "acceptNote"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success",
      "flat": "",
      "loading": _vm.savingCtnSheet
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveCtnSheet($event)
      }
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "grey",
      "flat": "",
      "disabled": _vm.savingCtnSheet
    },
    nativeOn: {
      "click": function($event) {
        _vm.ctnSheetDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "290"
    },
    model: {
      value: (_vm.submittedDialog),
      callback: function($$v) {
        _vm.submittedDialog = $$v
      },
      expression: "submittedDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Connection Sheet Submitted")]), _vm._v(" "), _c('v-card-text', [_vm._v("The connection sheet has been submitted for approval by support. Reference No: " + _vm._s(_vm.submittedRef) + ".")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "grey",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reset($event)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "350"
    },
    model: {
      value: (_vm.vehicleRegDialog),
      callback: function($$v) {
        _vm.vehicleRegDialog = $$v
      },
      expression: "vehicleRegDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Update Vehicle Registration")]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    ref: "updateVehicleRegInput",
    attrs: {
      "label": "Vehicle Reg.",
      "autofocus": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveVehicleReg($event)
      }
    },
    model: {
      value: (_vm.vehicleRegDialogData.Reg),
      callback: function($$v) {
        _vm.$set(_vm.vehicleRegDialogData, "Reg", $$v)
      },
      expression: "vehicleRegDialogData.Reg"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success",
      "flat": ""
    },
    on: {
      "click": _vm.saveVehicleReg
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "grey",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.vehicleRegDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('new-vehicle-dialog', {
    attrs: {
      "dialog": _vm.addVehicleDialog,
      "customer": _vm.customer
    },
    on: {
      "vehicleAdded": _vm.newVehicleAdded,
      "update:dialog": function($event) {
        _vm.addVehicleDialog = $event
      }
    }
  }), _vm._v(" "), _c('contact-edit-dialog', {
    attrs: {
      "contactID": null,
      "customer": _vm.customer,
      "customers": _vm.customerObj,
      "contactDialog": _vm.contactDialog
    },
    on: {
      "getContacts": _vm.step6,
      "update:contactDialog": function($event) {
        _vm.contactDialog = $event
      },
      "update:contact-dialog": function($event) {
        _vm.contactDialog = $event
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e3e3a7d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ServiceCalls.vue
// module id = 745
// module chunks = 1